import { observer } from 'mobx-react';
import { avatarFrom } from '../../../../../../Avatar';
import { emptyFragment } from '../../../../../../EmptyFragment';
import { findLink } from '../../../../../../LinkyLinky';
import ParticipantStore from '../../../../../../ParticipantStore';
import { NotTranslated } from '../../../../../../Translations';
import PersonPhoto from '../../../../../PersonPhoto';

interface Props {
  participantStore: ParticipantStore;
}

function ParticipantInfo({ participantStore }: Props) {
  return (
    <div className="flex py-4 gap-2 items-center">
      <div className="flex" data-test-person={true}>
        <div
          className="relative h-10 w-10 min-w-[100%] rounded-full bg-[#187A90]"
          data-test-person-avatar={true}
        >
          <PersonPhoto
            avatar={avatarFrom(
              findLink('avatar', participantStore.resource.links),
              participantStore.resource.payload.initials,
            )}
          />
        </div>
      </div>
      <span>
        {participantStore.resource.payload.fullName
          .map((name) => (
            <div>
              <NotTranslated text={name} />
            </div>
          ))
          .getOrElse(emptyFragment)}
        <div className="text-sm">
          <NotTranslated text={participantStore.resource.payload.email} />
        </div>
      </span>
    </div>
  );
}

export default observer(ParticipantInfo);
